export const governanceApproverMultiSigABI = [
    {
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'sender', internalType: 'address', type: 'address', indexed: true },
            { name: 'transactionId', internalType: 'uint256', type: 'uint256', indexed: true },
        ],
        name: 'Confirmation',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'sender', internalType: 'address', type: 'address', indexed: true },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'Deposit',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'transactionId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'returnData', internalType: 'bytes', type: 'bytes', indexed: false },
        ],
        name: 'Execution',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'internalRequired', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'InternalRequirementChange',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'owner', internalType: 'address', type: 'address', indexed: true }],
        name: 'OwnerAddition',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'owner', internalType: 'address', type: 'address', indexed: true }],
        name: 'OwnerRemoval',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'required', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'RequirementChange',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'sender', internalType: 'address', type: 'address', indexed: true },
            { name: 'transactionId', internalType: 'uint256', type: 'uint256', indexed: true },
        ],
        name: 'Revocation',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'transactionId', internalType: 'uint256', type: 'uint256', indexed: true }],
        name: 'Submission',
    },
    { payable: true, stateMutability: 'payable', type: 'fallback' },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'MAX_OWNER_COUNT',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
        name: 'addOwner',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_internalRequired', internalType: 'uint256', type: 'uint256' }],
        name: 'changeInternalRequirement',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_required', internalType: 'uint256', type: 'uint256' }],
        name: 'changeRequirement',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'transactionId', internalType: 'uint256', type: 'uint256' }],
        name: 'confirmTransaction',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'address', type: 'address' },
        ],
        name: 'confirmations',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'transactionId', internalType: 'uint256', type: 'uint256' }],
        name: 'executeTransaction',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'transactionId', internalType: 'uint256', type: 'uint256' }],
        name: 'getConfirmationCount',
        outputs: [{ name: 'count', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'transactionId', internalType: 'uint256', type: 'uint256' }],
        name: 'getConfirmations',
        outputs: [{ name: '_confirmations', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getOwners',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'pending', internalType: 'bool', type: 'bool' },
            { name: 'executed', internalType: 'bool', type: 'bool' },
        ],
        name: 'getTransactionCount',
        outputs: [{ name: 'count', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'from', internalType: 'uint256', type: 'uint256' },
            { name: 'to', internalType: 'uint256', type: 'uint256' },
            { name: 'pending', internalType: 'bool', type: 'bool' },
            { name: 'executed', internalType: 'bool', type: 'bool' },
        ],
        name: 'getTransactionIds',
        outputs: [{ name: '_transactionIds', internalType: 'uint256[]', type: 'uint256[]' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: '_owners', internalType: 'address[]', type: 'address[]' },
            { name: '_required', internalType: 'uint256', type: 'uint256' },
            { name: '_internalRequired', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'initialize',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'internalRequired',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'transactionId', internalType: 'uint256', type: 'uint256' }],
        name: 'isConfirmed',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'isOwner',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
        name: 'owners',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
        name: 'removeOwner',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'owner', internalType: 'address', type: 'address' },
            { name: 'newOwner', internalType: 'address', type: 'address' },
        ],
        name: 'replaceOwner',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'required',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'transactionId', internalType: 'uint256', type: 'uint256' }],
        name: 'revokeConfirmation',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'destination', internalType: 'address', type: 'address' },
            { name: 'value', internalType: 'uint256', type: 'uint256' },
            { name: 'data', internalType: 'bytes', type: 'bytes' },
        ],
        name: 'submitTransaction',
        outputs: [{ name: 'transactionId', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'transactionCount',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
        name: 'transactions',
        outputs: [
            { name: 'destination', internalType: 'address', type: 'address' },
            { name: 'value', internalType: 'uint256', type: 'uint256' },
            { name: 'data', internalType: 'bytes', type: 'bytes' },
            { name: 'executed', internalType: 'bool', type: 'bool' },
        ],
    },
];
